import React from 'react';
import TrainingPage from '../components/training/TrainingPage';
import trainingContent from '../config/trainingContent';

export default function ChatGPTEnterpriseTraining() {
  return (
    <TrainingPage
      seo={{
        title: "ChatGPT Enterprise Training for Teams | Eagentix",
        description: "1-day onsite ChatGPT Enterprise training. Your team builds and publishes a shared custom GPT on your own files, analyses real spreadsheets, and leaves with a verification standard."
      }}
      content={trainingContent.chatgpt}
    />
  );
}
